var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simple-layout"},[_c('SimpleHeader'),_c('Sidebar'),_c('Attention'),_c('div',{staticClass:"main"},[_c('Notifications'),_vm._t("default")],2),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }